import { FunctionComponent, useState } from "react"
import { Col, Row } from "react-bootstrap"
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import Container from "react-bootstrap/Container"
import Table from "react-bootstrap/Table"
import { useNavigate } from "react-router-dom"
import { ConfigScriptTemplate } from "../data/models"
import useQuery from "../hooks/useQuery"

interface ITemplatesPage {}
const TemplatesPage: FunctionComponent<ITemplatesPage> = () => {
	const navigate = useNavigate()
	const templatesQuery = useQuery<void, TemplatesOutput>(process.env.REACT_APP_KNIT_URL + "config-script-templates")
	const [sortProperty, setSortProperty] = useState<string | null>()
	const [sortDirection, setSortDirection] = useState<"ASC" | "DESC">("ASC")
	//sorting
	const handleSetSortProperty = (property: string) => {
		if (sortProperty === property) {
			setSortDirection(sortDirection === "ASC" ? "DESC" : "ASC")
		} else {
			setSortProperty(property)
			setSortDirection("ASC")
		}
	}
	let filteredTemplates = templatesQuery.data?.configScriptTemplates
	if (sortProperty) {
		filteredTemplates?.sort((a: any, b: any) => {
			if (a[sortProperty] && !b[sortProperty]) return -1
			if (!a[sortProperty] && b[sortProperty]) return 1
			if ((a[sortProperty] || "") < (b[sortProperty] || "")) return sortDirection === "ASC" ? -1 : 1
			if ((a[sortProperty] || "") > (b[sortProperty] || "")) return sortDirection === "ASC" ? 1 : -1
			return 0
		})
	}
	//
	const openTemplate = (template: ConfigScriptTemplate) => {
		navigate(template.id)
	}
	const loading = !templatesQuery.data || templatesQuery.loading
	//
	if (loading) {
		return (
			<Container style={{ maxWidth: 500 }}>
				<h2 className="text-center mt-4">Config Script Templates</h2>
				<div className="text-center">Loading</div>
			</Container>
		)
	}
	return (
		<Container>
			<h2 className="text-center mt-4">Config Script Templates</h2>
			{templatesQuery.error && <Alert variant={"warning"}>{templatesQuery.error}</Alert>}
			<Table striped bordered hover size="sm">
				<thead>
					<tr>
						<th onClick={() => handleSetSortProperty("name")}>Name</th>
						<th onClick={() => handleSetSortProperty("type")}>Type</th>
						<th onClick={() => handleSetSortProperty("model")}>Model</th>
						<th onClick={() => handleSetSortProperty("osVersion")}>RouterOS Version</th>
					</tr>
				</thead>
				<tbody>
					{filteredTemplates?.map((template) => {
						return (
							<tr key={template.id} onClick={() => openTemplate(template)}>
								<td>{template.name}</td>
								<td>{template.type}</td>
								<td>{template.model}</td>
								<td>{template.osVersion}</td>
							</tr>
						)
					})}
				</tbody>
			</Table>
			<Row>
				<Col xs="auto">
					<Button variant="secondary" onClick={() => navigate(-1)}>
						Back
					</Button>
				</Col>
				<Col></Col>
				<Col xs="auto">
					<Button variant="primary" onClick={() => navigate("new")}>
						New
					</Button>
				</Col>
			</Row>
		</Container>
	)
}

export default TemplatesPage

interface TemplatesOutput {
	configScriptTemplates: ConfigScriptTemplate[]
}
